var c = (b, p, r) => new Promise((i, o) => {
  var d = (e) => {
    try {
      a(r.next(e));
    } catch (l) {
      o(l);
    }
  }, u = (e) => {
    try {
      a(r.throw(e));
    } catch (l) {
      o(l);
    }
  }, a = (e) => e.done ? i(e.value) : Promise.resolve(e.value).then(d, u);
  a((r = r.apply(b, p)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { defineComponent as k, useTemplateRef as C, onMounted as F, openBlock as h, createElementBlock as D, createElementVNode as g, createVNode as n, withCtx as f, createTextVNode as U, Fragment as B } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as m, unref as s } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { useMessage as E } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import M from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import T from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import V from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/data-table/src/DataTable.js";
import S from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import z from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const I = { style: { width: "100%", display: "flex", "justify-content": "center" } }, P = /* @__PURE__ */ k({
  __name: "aiUrgentFailDialog",
  emits: ["submit"],
  setup(b, { expose: p, emit: r }) {
    const i = C("aiUrgentFailDialogContainer"), o = m(!1), d = m([]), u = m(!1), a = E(), e = [
      {
        title: "合同自编号",
        key: "OrderSelfNum"
      },
      {
        title: "失败原因",
        key: "Msg"
      }
    ], l = () => c(this, null, function* () {
      o.value = !1, w("submit");
    }), y = m({
      orderId: ""
    });
    F(() => c(this, null, function* () {
    }));
    function v(x, t) {
      d.value = x, o.value = !0, a.error(t || "当前列表有订单加急失败");
    }
    const _ = () => {
      o.value = !1, y.value = {
        orderId: ""
      };
    }, w = r;
    return p({ open: v }), (x, t) => (h(), D(B, null, [
      g("div", {
        ref_key: "aiUrgentFailDialogContainer",
        ref: i
      }, null, 512),
      n(s(z), {
        bordered: "",
        show: o.value,
        "onUpdate:show": t[0] || (t[0] = (N) => o.value = N),
        "mask-closable": !1,
        "z-index": 9999,
        to: i.value || "body"
      }, {
        default: f(() => [
          n(s(M), { show: u.value }, {
            default: f(() => [
              n(s(T), {
                style: { width: "500px" },
                title: "",
                bordered: !1,
                role: "dialog",
                closable: "",
                onClose: _
              }, {
                default: f(() => [
                  t[2] || (t[2] = g("div", { style: { color: "red", "font-size": "16px", "font-weight": "bold", "margin-bottom": "10px" } }, " 执行订单加急失败! ", -1)),
                  n(s(V), {
                    columns: e,
                    data: d.value,
                    bordered: !1
                  }, null, 8, ["data"]),
                  g("div", I, [
                    n(s(S), {
                      onClick: l,
                      style: { "margin-left": "30px", "margin-top": "22px", "background-color": "#1890ff !important", "border-color": "#1890ff !important", "--n-border": "1px solid #1890ff", "--n-button-color": "#fff !important" },
                      type: "primary"
                    }, {
                      default: f(() => t[1] || (t[1] = [
                        U("确认", -1)
                      ])),
                      _: 1,
                      __: [1]
                    })
                  ])
                ]),
                _: 1,
                __: [2]
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  P as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-urgent-dialog/aiUrgentFailDialog.vue.js
// module id = 1166
// module chunks = 41